import IpsCountdown from './IpsCountdown.vue';
import '../../../styles/custom.scss';

export default IpsCountdown;
